/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConcernedSubjectDto } from './concernedSubjectDto.model';


export interface ListResponseConcernedSubjectDto { 
    itemCount?: number;
    items?: Array<ConcernedSubjectDto>;
    params?: { [key: string]: any; };
}

